.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 25vh;
  .grid-states {
    .loading-container {
      display: none;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;

      gz-progress-spinner {
        display: flex;
        justify-content: center;
      }
    }

    &.is-loading {
      .form-wrapper {
        display: none;
      }

      .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: absolute;
      }
    }

    .no-results {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      gz-image-repo {
        height: auto;
      }

      .no-results-additional-data {
        text-align: center;
      }
    }
  }
}

.items {
  display: block;

  .row {
    display: flex;
    width: 100%;
  }
}

.footer {
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  gz-pagination {
    width: fit-content;
    --grid-border-color: var(--chart-101-pressed-dividers);
  }
}
